module.exports = __webpack_public_path__ + "img/t_q1.e2a88c38.jpeg";